import { Suspense } from 'react';
import { AddMemberInviteByEmailCollapsible } from 'assets/js/pages/campaign-settings/campaign-members/AddMemberInviteByEmailCollapsible';
import { AddMemberLinkCollapsible } from 'assets/js/pages/campaign-settings/campaign-members/AddMemberLinkCollapsible';
import { AddMemberManualFormCollapsible } from 'assets/js/pages/campaign-settings/campaign-members/AddMemberManualFormCollapsible';
import * as Dialog from 'components/dialog';

const CampaignMembersAddMemberDialog = () => (
    <Dialog.Body>
        <Dialog.Header>
            <Dialog.Title>Add team members</Dialog.Title>
            <Dialog.Close />
        </Dialog.Header>
        <div className={'flex flex-col gap-4'}>
            <AddMemberLinkCollapsible />
            <AddMemberInviteByEmailCollapsible />
            <Suspense fallback={null}>
                <AddMemberManualFormCollapsible />
            </Suspense>
        </div>
    </Dialog.Body>
);

export { CampaignMembersAddMemberDialog };
